// @flow
import Router from 'next/router'
import { merge } from 'timm'

import { actions as apiActions } from '../api'
import apiRequest from '../api/request'
import {
  actionCreators as flashMessageActionCreators,
  MessageTypeSuccess,
  MessageTypeFailure
  // $FlowIgnore TS import
} from '../flashMessage'
import { getJsonApiClient, setEntityModel } from '../api/apiClient'
// $FlowIgnore TS import
import type { Action, AsyncAction } from '../../types/Action'
import type { Entity } from '../../types/Entity'
// $FlowIgnore TS import
import type { GetState } from '../../types/ReduxType'
import { login } from '../routes'

// Constants
export const ENTITY: Entity = 'password_update'
const flashMessages = {
  success: () => [
    {
      id: 'update-password.success'
    }
  ],
  failure: () => [
    {
      id: 'update-password.failure'
    }
  ]
}

// Actions
export const actions = {
  LOAD_UPDATE_PASSWORD_SUCCESS: apiActions.getItemSuccessActionName(ENTITY),
  LOAD_UPDATE_PASSWORD_FAILURE: apiActions.getFailureActionName(ENTITY),
  LOAD_UPDATE_PASSWORD_REQUEST: apiActions.getRequestActionName(ENTITY)
}

// Model and initial state
export const Model: {
  token: string,
  password: string,
  password_confirmation: string
} = {
  token: '',
  password: '',
  password_confirmation: ''
}

export const initialState: typeof Model & {
  error: boolean,
  isFetching: boolean
} = merge(Model, {
  error: false,
  isFetching: false
})

// Reducer
export default function reducer (
  state: typeof initialState = initialState,
  { payload, type }: Action
) {
  switch (type) {
    case actions.LOAD_UPDATE_PASSWORD_REQUEST:
      return merge(state, {
        error: false,
        isFetching: true
      })
    case actions.LOAD_UPDATE_PASSWORD_SUCCESS:
      if (payload instanceof Error) {
        return state
      }
      return merge(state, {
        error: false,
        isFetching: false
      })
    case actions.LOAD_UPDATE_PASSWORD_FAILURE:
      return merge(state, {
        error: true,
        isFetching: false
      })
    default:
      return state
  }
}

// Action creators
export const actionCreators = {
  loadUpdatePassword (token: string): AsyncAction {
    const createPayload = getFormUpdatePassword(token)
    return (dispatch: *) =>
      apiRequest({
        apiAction: 'post',
        apiModel: createPayload,
        apiUrl: getJsonApiClient().all(ENTITY),
        dispatch,
        entityName: ENTITY,
        flashMessages
      }).then(data => {
        const { href, as } = login({
          pathname: '/',
          search: global.location.search
        })
        Router.push(href, as)
        return Promise.resolve(data)
      })
  }
}

// Side effects
setEntityModel(ENTITY, Model)

export function getFormUpdatePassword (token: string) {
  const passwordElement = document.getElementById('password')
  const passwordConfirmationElement = document.getElementById(
    'password_confirmation'
  )

  if (
    !token ||
    !(passwordElement instanceof HTMLInputElement) ||
    !(passwordConfirmationElement instanceof HTMLInputElement)
  ) {
    return {}
  }

  return {
    token,
    password: passwordElement.value,
    password_confirmation: passwordConfirmationElement.value
  }
}
